<template>
    <b-modal
      title="Detalhes"
      no-close-on-backdrop
      size="xl"
      ok-only
      centered
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
      <b-row class="container">
        <b-col cols="12" class="mb-4 text-center">
          <img 
            :src="formatImg(data.photos[0].foto_png)" 
            :alt="data.productName" 
            class="formatImg"
          >
          <hr>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>Código de Barras: </strong> {{ data.codbar }}</span>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>Produto: </strong> {{ data.productName }}</span>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>Marca: </strong> {{ data.brand }}</span>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>Cliente: </strong> {{ data.client }}</span>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>Email: </strong> {{ data.email }}</span>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>WhatsApp: </strong> {{ formatPhone(data.whatsapp) }}</span>
        </b-col>
        <b-col cols="12" class="mb-2">
          <span class="fs-18"><strong>Data da Solicitação: </strong> {{ data.dateRequestClient }}</span>
        </b-col>
      </b-row>
    </b-modal>
</template>
<script>



export default {
  name: 'WaitingProductDetails',
  
  data() {
    return {
      loading: false,
      open: false,
      data: '',
    };
  },

  methods: {
    toggleOpen({ data = [] }) {
      this.open = !this.open;
      this.data = data;
    },
    formatPhone(value) {
      if (!value) return ""
      value = value.replace(/\D/g,'')
      value = value.replace(/(\d{2})(\d)/,"($1) $2")
      value = value.replace(/(\d)(\d{4})$/,"$1-$2")
      return value
    },
    formatImg(img) {
      return process.env.VUE_APP_FOTOS_URL+img;
    },
  },
};
</script>
<style scoped>
  .formatImg {
    width: 100px;
  }
</style>
